export default __webpack_public_path__ + "static/shbfinance-0550d2977c2c11ba890bc62aa5a7c44c.png";